import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  Link,
} from 'react-router-dom';

import {
  useAuth,
} from '../../auth/AuthContext';

function normalizeUserAuthList(
  value,
) {
  if (Array.isArray(value)) {
    return value
      .map((auth) =>
        String(auth || '')
          .trim()
          .toUpperCase(),
      )
      .filter(Boolean);
  }

  return String(value || '')
    .split('|')
    .map((auth) =>
      String(auth || '')
        .trim()
        .toUpperCase(),
    )
    .filter(Boolean);
}

export default function UpdateNoticeSidebar({
  sidebarTree = [],
  expandedPrograms = {},
  expandedPlatforms = {},
  selectedNoticeSeq = null,
  isAllNoticesSelected = false,
  onAllNoticesClick = () => {},
  onProgramClick = () => {},
  onPlatformClick = () => {},
  onProgramFilter = () => {},
  onPlatformFilter = () => {},
  onNoticeClick = () => {},
}) {
  const { t } = useTranslation('app');
  const {
    user,
  } = useAuth();

  /*
   * 백엔드에서 내려준 userAuth에
   * HW 권한이 있을 때만 공지 관리 버튼을 표시합니다.
   */
  const canManageUpdateNotice =
    normalizeUserAuthList(
      user?.userAuth ||
      user?.user_auth,
    ).includes('HW');

  return (
    <div className="tree-wrap">
      <div className="updatenotice-sidebar-tree-content">
        <button
          type="button"
          className={[
            'program-toggle',
            'updatenotice-sidebar-root-item',
            isAllNoticesSelected ? 'is-active' : '',
          ]
            .filter(Boolean)
            .join(' ')}
          onClick={onAllNoticesClick}
        >
          <span className="toggle-mark" aria-hidden="true">
            •
          </span>
          <span className="program-label">
            {t('navigation.updatenoticesAll', 'All Update Notices')}
          </span>
        </button>

        {sidebarTree.map(
          (program) => {
            const isProgramOpen =
              Boolean(
                expandedPrograms[
                  program.name
                ],
              );

            return (
              <div
                key={
                  program.name
                }
                className="program-node"
              >
                <button
                  type="button"
                  className={[
                    'program-toggle',

                    isProgramOpen
                      ? 'is-active'
                      : '',
                  ]
                    .filter(Boolean)
                    .join(' ')}
                  onClick={() => {
                    onProgramClick(
                      program.name,
                    );
                  }}
                >
                  <span className="toggle-mark">
                    {isProgramOpen
                      ? '-'
                      : '+'}
                  </span>

                  <span
                    className="program-label"
                    role="button"
                    tabIndex={0}
                    onClick={(
                      event,
                    ) => {
                      event.stopPropagation();

                      onProgramFilter(
                        program.name,
                      );
                    }}
                    onKeyDown={(
                      event,
                    ) => {
                      if (
                        event.key !==
                          'Enter' &&
                        event.key !==
                          ' '
                      ) {
                        return;
                      }

                      event.preventDefault();
                      event.stopPropagation();

                      onProgramFilter(
                        program.name,
                      );
                    }}
                  >
                    {program.name}
                  </span>
                </button>

                {isProgramOpen && (
                  <>
                    {program.platforms
                      .length > 0 ? (
                      <div className="platform-list">
                        {program.platforms.map(
                          (
                            platform,
                          ) => {
                            const platformKey =
                              `${program.name}::${platform.name}`;

                            const isPlatformOpen =
                              Boolean(
                                expandedPlatforms[
                                  platformKey
                                ],
                              );

                            return (
                              <div
                                key={
                                  platformKey
                                }
                                className="platform-node"
                              >
                                <button
                                  type="button"
                                  className={[
                                    'platform-toggle',

                                    isPlatformOpen
                                      ? 'is-active'
                                      : '',
                                  ]
                                    .filter(Boolean)
                                    .join(' ')}
                                  onClick={() => {
                                    onPlatformClick(
                                      program.name,
                                      platform.name,
                                    );
                                  }}
                                >
                                  <span className="toggle-mark">
                                    {isPlatformOpen
                                      ? '-'
                                      : '+'}
                                  </span>

                                  <span
                                    className="platform-label"
                                    role="button"
                                    tabIndex={0}
                                    onClick={(
                                      event,
                                    ) => {
                                      event.stopPropagation();

                                      onPlatformFilter(
                                        program.name,
                                        platform.name,
                                      );
                                    }}
                                    onKeyDown={(
                                      event,
                                    ) => {
                                      if (
                                        event.key !==
                                          'Enter' &&
                                        event.key !==
                                          ' '
                                      ) {
                                        return;
                                      }

                                      event.preventDefault();
                                      event.stopPropagation();

                                      onPlatformFilter(
                                        program.name,
                                        platform.name,
                                      );
                                    }}
                                  >
                                    {platform.name}
                                  </span>
                                </button>

                                {isPlatformOpen && (
                                  <div className="notice-list">
                                    {platform
                                      .notices
                                      .length >
                                    0 ? (
                                      platform.notices.map(
                                        (
                                          notice,
                                        ) => {
                                          const isSelected =
                                            Number(
                                              selectedNoticeSeq,
                                            ) ===
                                            Number(
                                              notice.seq,
                                            );

                                          return (
                                            <Link
                                              key={
                                                `${notice.seq}-${notice.title}`
                                              }
                                              to={`/updatenotices/${notice.seq}`}
                                              className={[
                                                'notice-link',

                                                isSelected
                                                  ? 'is-active'
                                                  : '',
                                              ]
                                                .filter(
                                                  Boolean,
                                                )
                                                .join(
                                                  ' ',
                                                )}
                                              onClick={() => {
                                                onNoticeClick(
                                                  notice,
                                                );
                                              }}
                                            >
                                              {notice.version ||
                                                '-'}
                                            </Link>
                                          );
                                        },
                                      )
                                    ) : (
                                      <div className="empty-node" />
                                    )}
                                  </div>
                                )}
                              </div>
                            );
                          },
                        )}
                      </div>
                    ) : (
                      <div className="notice-list direct-notice-list">
                        {program
                          .directNotices
                          .length >
                        0 ? (
                          program.directNotices.map(
                            (
                              notice,
                            ) => {
                              const isSelected =
                                Number(
                                  selectedNoticeSeq,
                                ) ===
                                Number(
                                  notice.seq,
                                );

                              return (
                                <Link
                                  key={
                                    `${notice.seq}-${notice.title}`
                                  }
                                  to={`/updatenotices/${notice.seq}`}
                                  className={[
                                    'notice-link',

                                    isSelected
                                      ? 'is-active'
                                      : '',
                                  ]
                                    .filter(
                                      Boolean,
                                    )
                                    .join(
                                      ' ',
                                    )}
                                  onClick={() => {
                                    onNoticeClick(
                                      notice,
                                    );
                                  }}
                                >
                                  {notice.version ||
                                    '-'}
                                </Link>
                              );
                            },
                          )
                        ) : (
                          <div className="empty-node" />
                        )}
                      </div>
                    )}
                  </>
                )}
              </div>
            );
          },
        )}
      </div>
      {canManageUpdateNotice && (
        <div className="updatenotice-sidebar-admin">
          <Link
            to="/updatenotices/admin"
            className="updatenotice-secondary-button"
          >
            공지 관리
          </Link>
        </div>
      )}
    </div>
  );
}
